import type { TemplateConfig, TemplateId } from '../types';

// Static imports — Vite resolves these at build time.
// When the server is introduced, swap these for a GET /api/templates call.
import classicNews from '../templates/configs/classic-news.json';
import breakingNews from '../templates/configs/breaking-news.json';
import youtubeShorts from '../templates/configs/youtube-shorts.json';

// Cast JSON imports to TemplateConfig. TypeScript resolveJsonModule handles this.
const ALL_TEMPLATES: TemplateConfig[] = [
  classicNews as unknown as TemplateConfig,
  breakingNews as unknown as TemplateConfig,
  youtubeShorts as unknown as TemplateConfig,
];

/**
 * Returns all available template configs.
 * In future: replaces the static array with fetch('/api/templates').
 */
export async function fetchAllTemplates(): Promise<TemplateConfig[]> {
  // Simulate async for easy swap to real API later
  return Promise.resolve(ALL_TEMPLATES);
}

/**
 * Returns a single template config by ID, or null if not found.
 */
export async function fetchTemplateById(id: TemplateId): Promise<TemplateConfig | null> {
  const template = ALL_TEMPLATES.find((t) => t.metadata.id === id) ?? null;
  return Promise.resolve(template);
}

/**
 * Validates that a given object looks like a TemplateConfig.
 * Lightweight structural check — not a full JSON Schema validator.
 */
export function isValidTemplateConfig(obj: unknown): obj is TemplateConfig {
  if (typeof obj !== 'object' || obj === null) return false;
  const t = obj as Record<string, unknown>;
  return (
    typeof t.metadata === 'object' &&
    typeof t.colorPalette === 'object' &&
    typeof t.safeMargins === 'object' &&
    Array.isArray(t.layers)
  );
}
